import React, { useCallback, useEffect, useState } from 'react';
import '../styles/NewHeader.css';
import AllSvg from './AllSvg';
import { chkMobile, getToken, noneFilter, toJavaScriptString } from '../js/calculator';
import { getCookie, useAuth } from '../js/login';
import axios from 'axios';
import { useLocation } from 'react-router-dom';

const Navigation = ({ lang, bg }) => {
	const { cookieState, isLoading, error } = useAuth();
	const [scrollY, setScrollY] = useState(false); // 스크롤 위치(Y축)
	const [dropDown, setDropDown] = useState(false);
	const [aboutAlcDrop, setAboutAlcDrop] = useState(false);
	const [programDrop, setProgramDrop] = useState(false);
	const [speakersDrop, setSpeakersDrop] = useState(false);
	const [registerDrop, setRegisterDrop] = useState(false);
	const [hamburgerOpen, setHamburgerOpen] = useState(false);

	const resetDropdowns = () => {
		setDropDown(false);
		setAboutAlcDrop(false);
		setProgramDrop(false);
		setSpeakersDrop(false);
		setRegisterDrop(false);
		setHamburgerOpen(false);
	};

	const { pathname } = useLocation();

	const changeUrl = useCallback(() => {
		try {
			const currentUrl = window.location.href;

			// '/package' 경로 체크를 먼저 수행
			if (currentUrl.includes('/package')) {
				window.location.href = '/';
				return;
			}

			// 기업 참가등록에서 영문 눌렀을 경우 추가 분기처리
			if (currentUrl.includes('register-company')) {
				window.location.href = '/en/register';
				return;
			}

			// '/en' 포함 여부에 따른 처리
			if (currentUrl.includes('/en')) {
				// '/en' 제거
				const newUrl = currentUrl.replace('/en/', '/').replace('/en', '');
				window.location.href = newUrl;
			} else {
				// URL을 도메인과 경로로 분리
				const url = new URL(currentUrl);
				const path = url.pathname.startsWith('/') ? url.pathname.slice(1) : url.pathname;

				// 새로운 URL 생성 ('/en' 추가)
				const newUrl = `${url.origin}/en/${path}${url.search}${url.hash}`;
				window.location.href = newUrl;
			}
		} catch (error) {
			console.error('Error changing URL:', error);
		}
	}, []);

	const classNameMobile = () => {
		if (scrollY) {
			if (bg === 'dark') {
				return 'alc-nav-hidden-menu-dark-sticky';
			} else {
				return 'alc-nav-hidden-menu-sticky';
			}
		} else {
			if (bg === 'dark') {
				return 'alc-nav-hidden-menu-dark';
			} else {
				return 'alc-nav-hidden-menu';
			}
		}
	};

	const forbidden = () => {
		alert(`${lang === 'en' ? 'Please log in and use it.' : '로그인 후 이용 부탁드립니다.'}`); // 경고창
		window.location.href =
			lang === 'en'
				? '//www.chosun.com/en/subscribe/signin/'
				: '//www.chosun.com/subscribe/signin/';
	};

	const checkRegister = async () => {
		const koUrl = '/mypage';
		axios
			.get(`${process.env.REACT_APP_BASE_URL}/v1/main/participant-type`, {
				headers: { Authorization: getToken() === null ? null : `Bearer ${getToken()}` },
			})
			// 성공
			.then(res => {
				const status = res?.data?.participantType;
				const lang = res?.data?.lang === 'ENG' ? '/en/mypage' : '/mypage';
				switch (status) {
					case '1': {
						// 개인
						return (window.location.href = `${lang}?type=individual`);
					}

					case '2': {
						// 무료
						return (window.location.href = `${lang}?type=free`);
					}

					case '3': {
						// 기업
						return (window.location.href = `${koUrl}?type=company`);
					}

					default:
						console.warn('알 수 없는 상태:', status);
				}
			})
			// 실패
			.catch(err => {
				if (lang === 'en') {
					alert(err?.response?.data?.msgEn);
				} else {
					alert(err?.response?.data?.msgKr);
				}
			});
	};

	const scrollEvent = () => {
		const STANDARD = 51;

		if (window.scrollY > STANDARD) {
			setScrollY(true);
		} else {
			setScrollY(false);
		}
	};

	useEffect(() => {
		window.addEventListener('scroll', scrollEvent);
		classNameMobile();
	}, [scrollY]);

	useEffect(() => {
		// 팝업 열렸을 때 scroll 막는 코드
		if (hamburgerOpen) document.body.style.overflow = 'hidden';
		return () => {
			document.body.style.overflow = 'unset';
		};
	}, [hamburgerOpen]);

	useEffect(() => {
		const pathToMenuMap = {
			'/about': 'menu1',
			'/venue': 'menu1',
			'/information': 'menu4',
			'/register': 'menu4',
			'/mypage': 'menu4',
			'/register-company': 'menu4',
			'/speaker': 'menu3',
			'/key-speakers': 'menu3',
			'/gallery': 'menu5',
			'/video': 'menu5',
			'/program': 'menu2',
			'/session': 'menu2',
			'/package': 'menu6',
		};

		// 모든 active 클래스 제거
		document.querySelectorAll('.active').forEach(el => {
			el.classList.remove('active');
		});

		// 모든 path fill 초기화
		document.querySelectorAll('.alc-nav-text-block path').forEach(path => {
			path.style.fill = '';
		});

		const normalizedPath = pathname.replace(/^\/en/, '');
		const menuId = pathToMenuMap[normalizedPath];

		if (menuId) {
			const menu = document.getElementById(menuId);
			menu?.classList.add('active');

			// path 요소의 fill 색상 변경 (menu6 제외)
			if (menuId !== 'menu6') {
				const parentBlock = menu?.closest('.alc-nav-text-block');
				if (parentBlock) {
					const path = parentBlock.querySelector('path');
					if (path) {
						path.style.fill = '#DA1C28';
					}
				}
			}
		}
	}, [pathname]);

	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth >= 1214) {
				resetDropdowns();
			}
		};

		window.addEventListener('resize', handleResize);
		resetDropdowns(); // 초기 실행

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return (
		<>
			{lang === 'en' ? (
				<div className="alc-nav-maobile-all">
					<div
						className={scrollY ? 'alc-nav-mobile-sticky' : 'alc-nav-mobile'}
						style={{ backgroundColor: bg === 'dark' ? '#222222' : '#ffffff' }}
					>
						<div
							onClick={() => {
								setHamburgerOpen(true);
							}}
							aria-hidden="true"
							style={{ cursor: 'pointer' }}
						>
							<AllSvg type="hamburger-bar" bg={bg} />
						</div>
						<a href={lang === 'en' ? '/en' : '/'}>
							<AllSvg type="alc-nav-logo" bg={bg} />
						</a>
						<button
							className="alc-nav-button"
							style={{ border: bg === 'dark' ? '1px solid #ffffff' : '1px solid #222222' }}
							onClick={() => {
								changeUrl();
							}}
						>
							<span id="move-href" style={{ color: bg === 'dark' ? '#ffffff' : '#222222' }}>
								한국어
							</span>
						</button>
					</div>
					{hamburgerOpen && (
						<div className={classNameMobile()}>
							<div
								className="exit-button-mobile"
								aria-hidden="true"
								onClick={() => {
									setHamburgerOpen(false);
								}}
							>
								<AllSvg type={bg === 'dark' ? 'exit-grey-dark' : 'exit-grey'} />
							</div>
							<div className="hamburger-text-menu">
								{/* <a
									href="/en/about"
									className={
										bg === 'dark' ? 'hamburger-text-menu-font-dark' : 'hamburger-text-menu-font'
									}
									style={{ marginBottom: '24px' }}
								>
									ALC
								</a> */}
								<div className="hamburger-text-menu-media margin-24">
									<div
										className="hamburger-menu-box"
										onClick={() => {
											setAboutAlcDrop(!aboutAlcDrop);
										}}
									>
										<span
											className={
												bg === 'dark' ? 'hamburger-text-menu-font-dark' : 'hamburger-text-menu-font'
											}
										>
											ALC
										</span>
										<AllSvg
											type={aboutAlcDrop ? 'hamburger-arrow-up' : 'hamburger-arrow-down'}
											bg={bg}
										/>
									</div>
									{aboutAlcDrop && (
										<>
											<a
												href="/en/about"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark margin-12'
														: 'hamburger-text-menu-media-font margin-12'
												}
											>
												About
											</a>
											<a
												href="/en/venue"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark'
														: 'hamburger-text-menu-media-font'
												}
											>
												Venue
											</a>
										</>
									)}
								</div>
								{/* <a
									href="/en/program"
									className={
										bg === 'dark' ? 'hamburger-text-menu-font-dark' : 'hamburger-text-menu-font'
									}
								>
									Program
								</a> */}
								<div className="hamburger-text-menu-media margin-24">
									<div
										className="hamburger-menu-box"
										onClick={() => {
											setProgramDrop(!programDrop);
										}}
									>
										<span
											className={
												bg === 'dark' ? 'hamburger-text-menu-font-dark' : 'hamburger-text-menu-font'
											}
										>
											Program
										</span>
										<AllSvg
											type={programDrop ? 'hamburger-arrow-up' : 'hamburger-arrow-down'}
											bg={bg}
										/>
									</div>
									{programDrop && (
										<>
											<a
												href="/en/program"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark margin-12'
														: 'hamburger-text-menu-media-font margin-12'
												}
											>
												Timetable
											</a>
											{/* <a
												href="/en/session"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark'
														: 'hamburger-text-menu-media-font'
												}
											>
												Sessions
											</a> */}
										</>
									)}
								</div>
								{/* <a
									href="/en/speaker"
									className={
										bg === 'dark' ? 'hamburger-text-menu-font-dark' : 'hamburger-text-menu-font'
									}
								>
									Speakers
								</a> */}
								<div className="hamburger-text-menu-media margin-24">
									<div
										className="hamburger-menu-box"
										onClick={() => {
											setSpeakersDrop(!speakersDrop);
										}}
									>
										<span
											className={
												bg === 'dark' ? 'hamburger-text-menu-font-dark' : 'hamburger-text-menu-font'
											}
										>
											Speakers
										</span>
										<AllSvg
											type={speakersDrop ? 'hamburger-arrow-up' : 'hamburger-arrow-down'}
											bg={bg}
										/>
									</div>
									{speakersDrop && (
										<>
											<a
												href="/en/key-speakers"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark margin-12'
														: 'hamburger-text-menu-media-font margin-12'
												}
											>
												Past Key Speakers
											</a>
											<a
												href="/en/speaker"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark'
														: 'hamburger-text-menu-media-font'
												}
											>
												ALC Speakers
											</a>
										</>
									)}
								</div>
								{/* <a
									href="/en/register"
									className={
										bg === 'dark' ? 'hamburger-text-menu-font-dark' : 'hamburger-text-menu-font'
									}
								>
									Register
								</a> */}
								<div className="hamburger-text-menu-media margin-24">
									<div
										className="hamburger-menu-box"
										onClick={() => {
											setRegisterDrop(!registerDrop);
										}}
									>
										<span
											className={
												bg === 'dark' ? 'hamburger-text-menu-font-dark' : 'hamburger-text-menu-font'
											}
										>
											Registration
										</span>
										<AllSvg
											type={registerDrop ? 'hamburger-arrow-up' : 'hamburger-arrow-down'}
											bg={bg}
										/>
									</div>
									{registerDrop && (
										<>
											<a
												href="/en/information"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark margin-12'
														: 'hamburger-text-menu-media-font margin-12'
												}
											>
												Information
											</a>
											<a
												href="/en/register"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark'
														: 'hamburger-text-menu-media-font'
												}
												style={{ marginBottom: '12px' }}
											>
												Register
											</a>
											<span
												onClick={() => {
													if (noneFilter.includes(cookieState)) {
														forbidden();
													} else {
														checkRegister();
													}
												}}
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark'
														: 'hamburger-text-menu-media-font'
												}
											>
												My Page
											</span>
										</>
									)}
								</div>
								<a
									href="https://board.chosun.com/nbrd/bbs/list.html?b_bbs_id=10004&branch=20&pn="
									className={
										bg === 'dark' ? 'hamburger-text-menu-font-dark' : 'hamburger-text-menu-font'
									}
									style={{ marginBottom: '24px' }}
								>
									Notice
								</a>
								<div className="hamburger-text-menu-media margin-24">
									<div
										className="hamburger-menu-box"
										onClick={() => {
											setDropDown(!dropDown);
										}}
									>
										<span
											className={
												bg === 'dark' ? 'hamburger-text-menu-font-dark' : 'hamburger-text-menu-font'
											}
										>
											Media & News
										</span>
										<AllSvg
											type={dropDown ? 'hamburger-arrow-up' : 'hamburger-arrow-down'}
											bg={bg}
										/>
									</div>
									{dropDown && (
										<>
											<a
												href="/en/gallery"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark margin-12'
														: 'hamburger-text-menu-media-font margin-12'
												}
											>
												Gallery
											</a>
											<a
												href="/en/video"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark'
														: 'hamburger-text-menu-media-font'
												}
												style={{ marginBottom: '12px' }}
											>
												Video
											</a>
											<a
												href="https://www.chosun.com/tag/alc/"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark'
														: 'hamburger-text-menu-media-font'
												}
											>
												News
											</a>
										</>
									)}
								</div>
								<a
									href="/en/package"
									className={
										bg === 'dark' ? 'hamburger-text-menu-font-dark' : 'hamburger-text-menu-font'
									}
									style={{ marginBottom: '24px' }}
								>
									ALC Package
								</a>
								<a
									href="https://globalstudentstartup.org/"
									id="custom-link"
									className="alc-nav-gssc-mobile"
								>
									<img
										style={{ width: '36px', height: '36px' }}
										src={
											bg === 'dark'
												? 'https://image.chosun.com/alc/2026/gssc-logo-white.png'
												: 'https://image.chosun.com/alc/2026/gssc-logo.png'
										}
									/>
								</a>
							</div>
						</div>
					)}
				</div>
			) : (
				<div className="alc-nav-maobile-all">
					<div
						className={scrollY ? 'alc-nav-mobile-sticky' : 'alc-nav-mobile'}
						style={{ backgroundColor: bg === 'dark' ? '#222222' : '#ffffff' }}
					>
						<div
							onClick={() => {
								setHamburgerOpen(true);
							}}
							aria-hidden="true"
							style={{ cursor: 'pointer' }}
						>
							<AllSvg type="hamburger-bar" bg={bg} />
						</div>
						<a href={lang === 'en' ? '/en' : '/'}>
							<AllSvg type="alc-nav-logo" bg={bg} />
						</a>
						<button
							className="alc-nav-button"
							style={{ border: bg === 'dark' ? '1px solid #ffffff' : '1px solid #222222' }}
							onClick={() => {
								changeUrl();
							}}
						>
							<span id="move-href-en" style={{ color: bg === 'dark' ? '#ffffff' : '#222222' }}>
								English
							</span>
						</button>
					</div>
					{hamburgerOpen && (
						<div className={classNameMobile()}>
							<div
								className="exit-button-mobile"
								aria-hidden="true"
								onClick={() => {
									setHamburgerOpen(false);
									resetDropdowns();
								}}
							>
								<AllSvg type={bg === 'dark' ? 'exit-grey-dark' : 'exit-grey'} />
							</div>
							<div className="hamburger-text-menu">
								{/* <a
									href="/about"
									className={
										bg === 'dark' ? 'hamburger-text-menu-font-dark' : 'hamburger-text-menu-font'
									}
									style={{ marginBottom: '24px' }}
								>
									ALC 소개
								</a> */}
								<div className="hamburger-text-menu-media margin-24">
									<div
										className="hamburger-menu-box"
										onClick={() => {
											setAboutAlcDrop(!aboutAlcDrop);
										}}
									>
										<span
											className={
												bg === 'dark' ? 'hamburger-text-menu-font-dark' : 'hamburger-text-menu-font'
											}
										>
											ALC 소개
										</span>
										<AllSvg
											type={aboutAlcDrop ? 'hamburger-arrow-up' : 'hamburger-arrow-down'}
											bg={bg}
										/>
									</div>
									{aboutAlcDrop && (
										<>
											<a
												href="/about"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark margin-12'
														: 'hamburger-text-menu-media-font margin-12'
												}
											>
												ALC 소개
											</a>
											<a
												href="/venue"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark'
														: 'hamburger-text-menu-media-font'
												}
											>
												행사장 안내
											</a>
										</>
									)}
								</div>
								<div className="hamburger-text-menu-media margin-24">
									<div
										className="hamburger-menu-box"
										onClick={() => {
											setProgramDrop(!programDrop);
										}}
									>
										<span
											className={
												bg === 'dark' ? 'hamburger-text-menu-font-dark' : 'hamburger-text-menu-font'
											}
										>
											프로그램
										</span>
										<AllSvg
											type={programDrop ? 'hamburger-arrow-up' : 'hamburger-arrow-down'}
											bg={bg}
										/>
									</div>
									{programDrop && (
										<>
											<a
												href="/program"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark margin-12'
														: 'hamburger-text-menu-media-font margin-12'
												}
											>
												일정표
											</a>
											{/* <a
												href="/session"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark'
														: 'hamburger-text-menu-media-font'
												}
											>
												세션
											</a> */}
										</>
									)}
								</div>
								<div className="hamburger-text-menu-media margin-24">
									<div
										className="hamburger-menu-box"
										onClick={() => {
											setSpeakersDrop(!speakersDrop);
										}}
									>
										<span
											className={
												bg === 'dark' ? 'hamburger-text-menu-font-dark' : 'hamburger-text-menu-font'
											}
										>
											연사 소개
										</span>
										<AllSvg
											type={speakersDrop ? 'hamburger-arrow-up' : 'hamburger-arrow-down'}
											bg={bg}
										/>
									</div>
									{speakersDrop && (
										<>
											<a
												href="/key-speakers"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark margin-12'
														: 'hamburger-text-menu-media-font margin-12'
												}
											>
												역대 주요 연사
											</a>
											<a
												href="/speaker"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark'
														: 'hamburger-text-menu-media-font'
												}
											>
												연사 소개
											</a>
										</>
									)}
								</div>
								{/* <a
									href="/register"
									className={
										bg === 'dark' ? 'hamburger-text-menu-font-dark' : 'hamburger-text-menu-font'
									}
								>
									참가 등록
								</a> */}
								<div className="hamburger-text-menu-media margin-24">
									<div
										className="hamburger-menu-box"
										onClick={() => {
											setRegisterDrop(!registerDrop);
										}}
									>
										<span
											className={
												bg === 'dark' ? 'hamburger-text-menu-font-dark' : 'hamburger-text-menu-font'
											}
										>
											참가 등록
										</span>
										<AllSvg
											type={registerDrop ? 'hamburger-arrow-up' : 'hamburger-arrow-down'}
											bg={bg}
										/>
									</div>
									{registerDrop && (
										<>
											<a
												href="/information"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark margin-12'
														: 'hamburger-text-menu-media-font margin-12'
												}
											>
												등록 안내
											</a>
											<a
												href="/register"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark'
														: 'hamburger-text-menu-media-font'
												}
												style={{ marginBottom: '12px' }}
											>
												참가 등록
											</a>
											<span
												onClick={() => {
													if (noneFilter.includes(cookieState)) {
														forbidden();
													} else {
														checkRegister();
													}
												}}
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark'
														: 'hamburger-text-menu-media-font'
												}
											>
												등록 상태 확인
											</span>
										</>
									)}
								</div>
								<a
									href="https://board.chosun.com/nbrd/bbs/list.html?b_bbs_id=10004&branch=10&pn="
									className={
										bg === 'dark' ? 'hamburger-text-menu-font-dark' : 'hamburger-text-menu-font'
									}
									style={{ marginBottom: '24px' }}
								>
									공지사항
								</a>
								<div className="hamburger-text-menu-media margin-24">
									<div
										className="hamburger-menu-box"
										onClick={() => {
											setDropDown(!dropDown);
										}}
									>
										<span
											className={
												bg === 'dark' ? 'hamburger-text-menu-font-dark' : 'hamburger-text-menu-font'
											}
										>
											미디어&뉴스
										</span>
										<AllSvg
											type={dropDown ? 'hamburger-arrow-up' : 'hamburger-arrow-down'}
											bg={bg}
										/>
									</div>
									{dropDown && (
										<>
											<a
												href="/gallery"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark margin-12'
														: 'hamburger-text-menu-media-font margin-12'
												}
											>
												갤러리
											</a>
											<a
												href="/video"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark'
														: 'hamburger-text-menu-media-font'
												}
												style={{ marginBottom: '12px' }}
											>
												영상
											</a>
											<a
												href="https://www.chosun.com/tag/alc/"
												className={
													bg === 'dark'
														? 'hamburger-text-menu-media-font-dark'
														: 'hamburger-text-menu-media-font'
												}
											>
												뉴스
											</a>
										</>
									)}
								</div>
								<a
									href="https://globalstudentstartup.org/"
									id="custom-link"
									className="alc-nav-gssc-mobile"
								>
									<img
										style={{ width: '36px', height: '36px' }}
										src={
											bg === 'dark'
												? 'https://image.chosun.com/alc/2026/gssc-logo-white.png'
												: 'https://image.chosun.com/alc/2026/gssc-logo.png'
										}
									/>
								</a>
							</div>
						</div>
					)}
				</div>
			)}
			{lang === 'en' ? (
				<div
					className={scrollY ? 'alc-nav-all-container-sticky' : 'alc-nav-all-container'}
					style={{ background: bg === 'dark' ? '#222222' : '#ffffff' }}
				>
					<div
						className="alc-nav-inner"
						style={{ background: bg === 'dark' ? '#222222' : '#ffffff' }}
					>
						<a
							style={{ paddingLeft: '20px', marginRight: '28px' }}
							href={lang === 'en' ? '/en' : '/'}
						>
							<AllSvg type="alc-nav-logo" bg={bg} />
						</a>
						<div className="alc-nav-text-menu">
							{/* <a
								href="/en/about"
								id="menu1"
								className={bg === 'dark' ? 'alc-nav-text-dark' : 'alc-nav-text'}
								style={{ marginRight: '28px' }}
							>
								ALC
							</a> */}
							<div
								className="alc-nav-text-block"
								style={{ marginRight: '28px' }}
								onMouseEnter={() => {
									setAboutAlcDrop(true);
								}}
								onMouseLeave={() => {
									setAboutAlcDrop(false);
								}}
							>
								<a
									href="/en/about"
									id="menu1"
									className={bg === 'dark' ? 'alc-nav-text-dark' : 'alc-nav-text'}
									style={{
										color: aboutAlcDrop ? '#da1c28' : bg === 'dark' ? '#ffffff' : '#222222',
									}}
								>
									ALC
								</a>
								<AllSvg type={aboutAlcDrop ? 'arrow-up' : 'arrow-down'} bg={bg} />
								<div className="alc-media-dropdown">
									<ul className="alc-media-dropdown-ul">
										<a href="/en/about">
											<li className="alc-media-dropdown-text">About</li>
										</a>
										<a href="/en/venue">
											<li className="alc-media-dropdown-text">Venue</li>
										</a>
									</ul>
								</div>
							</div>
							<div
								className="alc-nav-text-block"
								style={{ marginRight: '28px' }}
								onMouseEnter={() => {
									setProgramDrop(true);
								}}
								onMouseLeave={() => {
									setProgramDrop(false);
								}}
							>
								<a
									href="/en/program"
									id="menu2"
									className={bg === 'dark' ? 'alc-nav-text-dark' : 'alc-nav-text'}
									style={{
										color: programDrop ? '#da1c28' : bg === 'dark' ? '#ffffff' : '#222222',
									}}
								>
									Program
								</a>
								<AllSvg type={programDrop ? 'arrow-up' : 'arrow-down'} bg={bg} />
								<div className="alc-media-dropdown">
									<ul className="alc-media-dropdown-ul">
										<a href="/en/program">
											<li className="alc-media-dropdown-text">Timetable</li>
										</a>
										{/* <a href="/en/session">
											<li className="alc-media-dropdown-text">Sessions</li>
										</a> */}
									</ul>
								</div>
							</div>
							{/* <div
								className="alc-nav-text-block"
								style={{ marginRight: '36px' }}
								onMouseEnter={() => {
									setProgramDrop(true);
								}}
								onMouseLeave={() => {
									setProgramDrop(false);
								}}
							>
								<a
									id="menu2"
									href="#"
									className={bg === 'dark' ? 'alc-nav-text-dark' : 'alc-nav-text'}
									style={{ color: programDrop ? '#da1c28' : bg === 'dark' ? '#ffffff' : '#222222' }}
								>
									Program
								</a>
								<AllSvg type={programDrop ? 'arrow-up' : 'arrow-down'} bg={bg} />
								<div className="alc-media-dropdown">
									<ul className="alc-media-dropdown-ul">
										<a href="/en/program">
											<li className="alc-media-dropdown-text">Timetable</li>
										</a>
										<a href="/en/session">
											<li className="alc-media-dropdown-text">Sessions</li>
										</a>
									</ul>
								</div>
							</div> */}
							<div
								className="alc-nav-text-block"
								style={{ marginRight: '28px' }}
								onMouseEnter={() => {
									setSpeakersDrop(true);
								}}
								onMouseLeave={() => {
									setSpeakersDrop(false);
								}}
							>
								<a
									href="/en/speaker"
									id="menu3"
									className={bg === 'dark' ? 'alc-nav-text-dark' : 'alc-nav-text'}
									style={{
										color: speakersDrop ? '#da1c28' : bg === 'dark' ? '#ffffff' : '#222222',
									}}
								>
									Speaker
								</a>
								<AllSvg type={speakersDrop ? 'arrow-up' : 'arrow-down'} bg={bg} />
								<div className="alc-media-dropdown">
									<ul className="alc-media-dropdown-ul">
										<a href="/en/key-speakers">
											<li className="alc-media-dropdown-text">Past Key Speakers</li>
										</a>
										<a href="/en/speaker">
											<li className="alc-media-dropdown-text">ALC Speakers</li>
										</a>
									</ul>
								</div>
							</div>
							{/* <a
								href="/en/register"
								className={bg === 'dark' ? 'alc-nav-text-dark' : 'alc-nav-text'}
								style={{ marginRight: '36px' }}
								id="menu4"
							>
								Register
							</a> */}
							<div
								className="alc-nav-text-block"
								style={{ marginRight: '28px' }}
								onMouseEnter={() => {
									setRegisterDrop(true);
								}}
								onMouseLeave={() => {
									setRegisterDrop(false);
								}}
							>
								<a
									href="/en/register"
									id="menu4"
									className={bg === 'dark' ? 'alc-nav-text-dark' : 'alc-nav-text'}
									style={{
										color: registerDrop ? '#da1c28' : bg === 'dark' ? '#ffffff' : '#222222',
									}}
								>
									Registration
								</a>
								<AllSvg type={registerDrop ? 'arrow-up' : 'arrow-down'} bg={bg} />
								<div className="alc-media-dropdown">
									<ul className="alc-media-dropdown-ul">
										<a href="/en/information">
											<li className="alc-media-dropdown-text">Information</li>
										</a>
										<a href="/en/register">
											<li className="alc-media-dropdown-text">Register</li>
										</a>
										<li
											className="alc-media-dropdown-text"
											onClick={event => {
												if (noneFilter.includes(cookieState)) {
													forbidden();
												} else {
													checkRegister();
												}
											}}
										>
											<span>My Page</span>
										</li>
									</ul>
								</div>
							</div>
							<a
								href="https://board.chosun.com/nbrd/bbs/list.html?b_bbs_id=10004&branch=20&pn="
								className={bg === 'dark' ? 'alc-nav-text-dark' : 'alc-nav-text'}
								style={{ marginRight: '28px' }}
							>
								Notice
							</a>
							<div
								className="alc-nav-text-block"
								style={{ marginRight: '28px' }}
								onMouseEnter={() => {
									setDropDown(true);
								}}
								onMouseLeave={() => {
									setDropDown(false);
								}}
							>
								<a
									href="/en/gallery"
									className={bg === 'dark' ? 'alc-nav-text-dark' : 'alc-nav-text'}
									style={{ color: dropDown ? '#da1c28' : bg === 'dark' ? '#ffffff' : '#222222' }}
									id="menu5"
								>
									Media & News
								</a>
								<AllSvg type={dropDown ? 'arrow-up' : 'arrow-down'} bg={bg} />
								<div className="alc-media-dropdown">
									<ul className="alc-media-dropdown-ul">
										<a href="/en/gallery">
											<li className="alc-media-dropdown-text">Gallery</li>
										</a>
										<a href="/en/video">
											<li className="alc-media-dropdown-text">Video</li>
										</a>
										<a href="https://www.chosun.com/tag/alc/">
											<li className="alc-media-dropdown-text">News</li>
										</a>
									</ul>
								</div>
							</div>
							{lang === 'en' && (
								<a
									href="/en/package"
									className={bg === 'dark' ? 'alc-nav-text-dark' : 'alc-nav-text'}
									style={{ marginRight: '36px' }}
									id="menu6"
								>
									ALC Package
								</a>
							)}
							<a href="https://globalstudentstartup.org/" id="custom-link" className="alc_nav_gssc">
								<img
									className="alc-nav-gssc"
									src={
										bg === 'dark'
											? 'https://image.chosun.com/alc/2026/gssc-logo-white.png'
											: 'https://image.chosun.com/alc/2026/gssc-logo.png'
									}
								/>
							</a>
							<button
								className="alc-nav-button"
								style={{ border: bg === 'dark' ? '1px solid #ffffff' : '1px solid #222222' }}
								onClick={() => {
									changeUrl();
								}}
							>
								<span id="move-href" style={{ color: bg === 'dark' ? '#ffffff' : '#222222' }}>
									한국어
								</span>
							</button>
						</div>
					</div>
				</div>
			) : (
				<div
					className={scrollY ? 'alc-nav-all-container-sticky' : 'alc-nav-all-container'}
					style={{ background: bg === 'dark' ? '#222222' : '#ffffff' }}
				>
					<div
						className="alc-nav-inner"
						style={{ background: bg === 'dark' ? '#222222' : '#ffffff' }}
					>
						<a
							style={{ paddingLeft: '20px', marginRight: '36px' }}
							href={lang === 'en' ? '/en' : '/'}
						>
							<AllSvg type="alc-nav-logo" bg={bg} />
						</a>
						<div className="alc-nav-text-menu">
							{/* <a
								href="/about"
								className={bg === 'dark' ? 'alc-nav-text-dark' : 'alc-nav-text'}
								style={{ marginRight: '36px' }}
								id="menu1"
							>
								ALC 소개
							</a> */}
							<div
								className="alc-nav-text-block"
								style={{ marginRight: '36px' }}
								onMouseEnter={() => {
									setAboutAlcDrop(true);
								}}
								onMouseLeave={() => {
									setAboutAlcDrop(false);
								}}
							>
								<a
									href="/about"
									id="menu1"
									className={bg === 'dark' ? 'alc-nav-text-dark' : 'alc-nav-text'}
									style={{
										color: aboutAlcDrop ? '#da1c28' : bg === 'dark' ? '#ffffff' : '#222222',
									}}
								>
									ALC 소개
								</a>
								<AllSvg type={aboutAlcDrop ? 'arrow-up' : 'arrow-down'} bg={bg} />
								<div className="alc-media-dropdown">
									<ul className="alc-media-dropdown-ul">
										<a href="/about">
											<li className="alc-media-dropdown-text">ALC 소개</li>
										</a>
										<a href="/venue">
											<li className="alc-media-dropdown-text">행사장 안내</li>
										</a>
									</ul>
								</div>
							</div>
							<div
								className="alc-nav-text-block"
								style={{ marginRight: '36px' }}
								onMouseEnter={() => {
									setProgramDrop(true);
								}}
								onMouseLeave={() => {
									setProgramDrop(false);
								}}
							>
								<a
									href="/program"
									id="menu2"
									className={bg === 'dark' ? 'alc-nav-text-dark' : 'alc-nav-text'}
									style={{
										color: programDrop ? '#da1c28' : bg === 'dark' ? '#ffffff' : '#222222',
									}}
								>
									프로그램
								</a>
								<AllSvg type={programDrop ? 'arrow-up' : 'arrow-down'} bg={bg} />
								<div className="alc-media-dropdown">
									<ul className="alc-media-dropdown-ul">
										<a href="/program">
											<li className="alc-media-dropdown-text">일정표</li>
										</a>
										{/* <a href="/session">
											<li className="alc-media-dropdown-text">세션</li>
										</a> */}
									</ul>
								</div>
							</div>
							{/* <div
								className="alc-nav-text-block"
								style={{ marginRight: '36px' }}
								onMouseEnter={() => {
									setProgramDrop(true);
								}}
								onMouseLeave={() => {
									setProgramDrop(false);
								}}
							>
								<a
									id="menu2"
									href="#"
									className={bg === 'dark' ? 'alc-nav-text-dark' : 'alc-nav-text'}
									style={{ color: programDrop ? '#da1c28' : bg === 'dark' ? '#ffffff' : '#222222' }}
								>
									프로그램
								</a>
								<AllSvg type={programDrop ? 'arrow-up' : 'arrow-down'} bg={bg} />
								<div className="alc-media-dropdown">
									<ul className="alc-media-dropdown-ul">
										<a href="/program">
											<li className="alc-media-dropdown-text">시간표</li>
										</a>
										<a href="/session">
											<li className="alc-media-dropdown-text">세션</li>
										</a>
									</ul>
								</div>
							</div> */}
							<div
								className="alc-nav-text-block"
								style={{ marginRight: '36px' }}
								onMouseEnter={() => {
									setSpeakersDrop(true);
								}}
								onMouseLeave={() => {
									setSpeakersDrop(false);
								}}
							>
								<a
									href="/speaker"
									id="menu3"
									className={bg === 'dark' ? 'alc-nav-text-dark' : 'alc-nav-text'}
									style={{
										color: speakersDrop ? '#da1c28' : bg === 'dark' ? '#ffffff' : '#222222',
									}}
								>
									연사 소개
								</a>
								<AllSvg type={speakersDrop ? 'arrow-up' : 'arrow-down'} bg={bg} />
								<div className="alc-media-dropdown">
									<ul className="alc-media-dropdown-ul">
										<a href="/key-speakers">
											<li className="alc-media-dropdown-text">역대 주요 연사</li>
										</a>
										<a href="/speaker">
											<li className="alc-media-dropdown-text">연사 소개</li>
										</a>
									</ul>
								</div>
							</div>
							{/* <a
								href="/register"
								className={bg === 'dark' ? 'alc-nav-text-dark' : 'alc-nav-text'}
								style={{ marginRight: '36px' }}
								id="menu4"
							>
								참가 등록
							</a> */}
							<div
								className="alc-nav-text-block"
								style={{ marginRight: '36px' }}
								onMouseEnter={() => {
									setRegisterDrop(true);
								}}
								onMouseLeave={() => {
									setRegisterDrop(false);
								}}
							>
								<a
									href="/register"
									id="menu4"
									className={bg === 'dark' ? 'alc-nav-text-dark' : 'alc-nav-text'}
									style={{
										color: registerDrop ? '#da1c28' : bg === 'dark' ? '#ffffff' : '#222222',
									}}
								>
									참가 등록
								</a>
								<AllSvg type={registerDrop ? 'arrow-up' : 'arrow-down'} bg={bg} />
								<div className="alc-media-dropdown">
									<ul className="alc-media-dropdown-ul">
										<a href="/information">
											<li className="alc-media-dropdown-text">등록 안내</li>
										</a>
										<a href="/register">
											<li className="alc-media-dropdown-text">참가 등록</li>
										</a>
										<li
											className="alc-media-dropdown-text"
											onClick={() => {
												if (noneFilter.includes(cookieState)) {
													forbidden();
												} else {
													checkRegister();
												}
											}}
										>
											<span>등록 상태 확인</span>
										</li>
									</ul>
								</div>
							</div>
							<a
								href="https://board.chosun.com/nbrd/bbs/list.html?b_bbs_id=10004&branch=10&pn="
								className={bg === 'dark' ? 'alc-nav-text-dark' : 'alc-nav-text'}
								style={{ marginRight: '36px' }}
							>
								공지사항
							</a>
							<div
								className="alc-nav-text-block"
								style={{ marginRight: '36px' }}
								onMouseEnter={() => {
									setDropDown(true);
								}}
								onMouseLeave={() => {
									setDropDown(false);
								}}
							>
								<a
									href="/gallery"
									className={bg === 'dark' ? 'alc-nav-text-dark' : 'alc-nav-text'}
									style={{ color: dropDown ? '#da1c28' : bg === 'dark' ? '#ffffff' : '#222222' }}
									id="menu5"
								>
									미디어&뉴스
								</a>
								<AllSvg type={dropDown ? 'arrow-up' : 'arrow-down'} bg={bg} />
								<div className="alc-media-dropdown">
									<ul className="alc-media-dropdown-ul">
										<a href="/gallery">
											<li className="alc-media-dropdown-text">갤러리</li>
										</a>
										<a href="/video">
											<li className="alc-media-dropdown-text">비디오</li>
										</a>
										<a href="https://www.chosun.com/tag/alc/">
											<li className="alc-media-dropdown-text">뉴스</li>
										</a>
									</ul>
								</div>
							</div>
							<a href="https://globalstudentstartup.org/" id="custom-link" className="alc_nav_gssc">
								<img
									className="alc-nav-gssc"
									src={
										bg === 'dark'
											? 'https://image.chosun.com/alc/2026/gssc-logo-white.png'
											: 'https://image.chosun.com/alc/2026/gssc-logo.png'
									}
								/>
							</a>
							<button
								className="alc-nav-button"
								style={{ border: bg === 'dark' ? '1px solid #ffffff' : '1px solid #222222' }}
								onClick={() => {
									changeUrl();
								}}
							>
								<span id="move-href-en" style={{ color: bg === 'dark' ? '#ffffff' : '#222222' }}>
									English
								</span>
							</button>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default Navigation;
